import { render, staticRenderFns } from "./rewardActivity.vue?vue&type=template&id=36256d5e"
import script from "./rewardActivity.vue?vue&type=script&lang=js"
export * from "./rewardActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports